@if (state() === 'otp') {
  <tc-otp
    [otpRequest]="otpRequest()"
    [otpDigitsFormArray]="form.controls.otpDigits"
    [isLoading]="isLoading()"
    [error]="error()"
    (submit)="submit()"
    (resendOtp)="resetPasswordInit()"
  >
  </tc-otp>

} @else if (state() === 'password') {

  <div class="form__control-container">
    @let passwordControl = form.controls.password;

    <label class="form__label" for="password">
      {{ 'global.new_password' | translate }}
    </label>
    <div class="form__control">
      <input
        class="form__input"
        [class.form__input--invalid]="isControlInvalid(passwordControl)"
        [formControl]="passwordControl"
        id="password"
        type="password"
        autocomplete="new-password"
      >

      @if (isControlInvalid(passwordControl)) {
        <div class="form__input-error">
          {{ 'global.required_field' | translate }}
        </div>
      }
    </div>
  </div>

  <div class="form__control-container">
    @let repeatPasswordControl = form.controls.repeatPassword;

    <label class="form__label" for="repeat-password">{{ 'global.repeat_new_password' | translate }}</label>
    <div class="form__control">
      <input
        class="form__input"
        [class.form__input--invalid]="isControlInvalid(repeatPasswordControl)"
        [formControl]="repeatPasswordControl"
        id="repeat-password"
        type="password"
        autocomplete="new-password"
      >

      @if (isControlInvalid(repeatPasswordControl)) {
        <div class="form__input-error">
          {{ 'global.passwords_dont_match' | translate }}
        </div>
      }
    </div>
  </div>

} @else if (state() === 'success') {

  <div class="success-header">
    {{ 'reset_password.success_header' | translate }}
  </div>

  <div class="success-text">
    {{ 'reset_password.success_text' | translate }}
  </div>
}

@if (state() !== 'otp') {
  @if (error()) {
    <div class="form__error">
      {{ error() }}
    </div>
  }

  <button
    class="btn form__submit reset-password-submit"
    [class.form__submit--loading]="isLoading()"
    (click)="submit()"
    type="submit"
  >
    @if (state() === 'otp') {
      {{ 'global.next' | translate }}
    } @else if (state() === 'success') {
      {{ 'global.done' | translate }}
    } @else {
      {{ 'global.confirm' | translate }}
    }

    @if (isLoading()) {
      <preloader class="btn-preloader"></preloader>
    }
  </button>
}
